__turbopack_context__.v({
  "desktopImage": "logo-module-scss-module__EJSCrq__desktopImage",
  "desktopImageSlim": "logo-module-scss-module__EJSCrq__desktopImageSlim",
  "image": "logo-module-scss-module__EJSCrq__image",
  "link": "logo-module-scss-module__EJSCrq__link",
  "logo": "logo-module-scss-module__EJSCrq__logo",
  "logoSlim": "logo-module-scss-module__EJSCrq__logoSlim",
  "mobileImage": "logo-module-scss-module__EJSCrq__mobileImage",
  "mobileImageSlim": "logo-module-scss-module__EJSCrq__mobileImageSlim",
  "pfLogo": "logo-module-scss-module__EJSCrq__pfLogo",
});
